import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
export const useIsLoggedIn = () => {
  const $ = _c(6);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [email, setEmail] = useState(null);
  const router = useRouter();
  const {
    isAuth
  } = router.query;
  let t0;
  let t1;
  if ($[0] !== isAuth) {
    t0 = () => {
      const authValue = sessionStorage.getItem("auth") || (isAuth === "true" ? "true" : null);
      const email_0 = localStorage.getItem("currentlyLoggedUserEmail");
      setIsLoggedIn(!!authValue);
      setEmail(email_0);
    };
    t1 = [isAuth];
    $[0] = isAuth;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== email || $[4] !== isLoggedIn) {
    t2 = {
      isLoggedIn,
      email
    };
    $[3] = email;
    $[4] = isLoggedIn;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};